import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-3xl mx-auto py-10 px-4 text-gray-700">
      <h1 className="text-3xl font-bold mb-6 text-center">Terms & Conditions</h1>

      <p className="mb-4">
        Welcome to our course registration website. By registering and making a payment, you agree to comply with the following terms and conditions. Please read them carefully before proceeding.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Course Enrollment</h2>
      <p className="mb-4">
        Enrollment is confirmed once the registration form is completed and the payment is successfully processed via UPI or other provided payment methods.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Payment Terms</h2>
      <p className="mb-4">
        Full payment is required at the time of registration. Once payment is received, a confirmation will be sent to the provided email address.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Refund Policy</h2>
      <p className="mb-4">
        All payments made are non-refundable. Please ensure that you have selected the correct course duration and language preference before proceeding with the payment.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Course Access</h2>
      <p className="mb-4">
        Upon successful registration, course access details and materials will be shared within 24-48 hours via email or designated communication channels.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. User Responsibilities</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Provide accurate and complete information during registration.</li>
        <li>Maintain confidentiality of course materials and avoid unauthorized sharing.</li>
        <li>Use the course content solely for personal learning purposes.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Intellectual Property</h2>
      <p className="mb-4">
        All course content, materials, and resources are the intellectual property of our institution and are protected by copyright laws.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Privacy Policy</h2>
      <p className="mb-4">
        Your personal data is collected for registration and communication purposes only. Please refer to our <a href="/privacy-policy" className="text-blue-600 underline">Privacy Policy</a> for detailed information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Modifications</h2>
      <p className="mb-4">
        We reserve the right to modify these terms at any time. Any changes will be updated on this page, and your continued use of our services constitutes acceptance of those changes.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Contact Information</h2>
      <p className="mb-4">
        For any questions or concerns regarding these terms, please contact us at:
      </p>
      <p className="mb-4 font-medium">📧 Email: learnersrider@gmail.com</p>
      <p className="mb-4 font-medium">📧 Contact: 9495083895</p>

      <p className="text-sm text-gray-500 mt-6">Last updated: July 2025</p>
    </div>
  );
};

export default TermsAndConditions;
